import { ACTION_TYPES } from "../../../constants/index";

const initialState = {
  items: [],
};

const businessReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_BUSINESS:
      return {
        ...state,
        items: action.payload,
      };
    case ACTION_TYPES.CLEAR_BUSINESS:
      return {
        ...state,
        items: [],
      };
    default:
      return state;
  }
};

export default businessReducer;
